<template>
  <div class="text-center">
    <input
      :disabled="playing"
      v-if="intervalShowing"
      v-model.number="timeInterval"
      type="number"
    />(ms)
    <v-btn v-if="!playing" color="blue-grey" class="ma-2 white--text" @click="play">
      Play
      <v-icon right dark>fas fa-play</v-icon>
    </v-btn>
    <v-btn v-else color="blue-grey" class="ma-2 white--text" @click="pause">
      Pause
      <v-icon right dark>fas fa-pause</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { EventBus } from "../event-bus.js";
import { clearInterval } from "timers";
export default {
  props: ["editor"],
  data() {
    return {
      playing: false,
      intervalShowing: true,
      timeInterval: 60,
      currentId: 0,
      wasTrue: false,
      currentIntervalProcess: null,
      intervalId:0,
    };
  },
  methods: {
    play() {
      this.playing = true;
      this.setNextUID();
// todo: function(){  
//     this.intervalid1 = setInterval(() => {
//         this.changes = ((Math.random() * 100).toFixed(2))+'%';
//         console.log (this.changes);
//     }, 3000);
// }
     this.intervalId = this.currentId;
      this.currentIntervalProcess = setInterval(()=>{this.triggerProcess()},this.timeInterval);
      EventBus.$emit("global-play-nodes", this.playing);
    },
    pause() {
      this.playing = false;
      this.setNextUID();
      if (this.currentIntervalProcess !== null) {
        window.clearInterval(this.currentIntervalProcess);
      }
      EventBus.$emit("global-play-nodes", this.playing);
    },
    triggerProcess() {
      if (this.currentId === this.intervalId ) {
        this.editor.trigger("process");
      } else {
        console.log("Current Id Changed");
      }
    },
    setNextUID() {
      if (this.currentId == Number.MAX_SAFE_INTEGER - 10) {
        this.currentId = 0;
      } else {
        this.currentId = this.currentId + 1;
      }
    }
  },
  watch: {
    timeInterval(oldValue, newValue) {
      if (oldValue !== newValue) {
        this.setNextUID();
        this.playing = false;
      }
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style  scoped>
input {
    text-align: right; 
}
</style>